import { TriangleAlert, CircleCheck } from 'lucide-react';
import { Alert, AlertDescription } from './ui/alert';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface ContextualAlertProps {
  message: string | ReactNode;
  variant?: 'warning' | 'error' | 'success';
  className?: string;
}

export function ContextualAlert({ message, variant = 'warning', className }: ContextualAlertProps) {
  return (
    <Alert
      className={cn(
        'flex flex-col gap-1 p-4 rounded-lg',
        variant === 'warning' && 'border-[#FED7AA] bg-[#FFEDD5]',
        variant === 'error' && 'border-[#FED7AA] bg-[#FFEDD5]',
        variant === 'success' && 'border-[#E4E4E7] bg-[#F0FDFA]',
        className
      )}
    >
      <div className="flex items-center gap-2">
        {variant === 'success' ? (
          <CircleCheck size={16} color="#0D9488" className="flex-shrink-0" />
        ) : (
          <TriangleAlert size={16} color="#EC5E49" className="flex-shrink-0" />
        )}
        <AlertDescription
          className={cn('flex-grow', variant === 'success' ? 'text-greenDark' : 'text-redLight')}
        >
          {message}
        </AlertDescription>
      </div>
    </Alert>
  );
}
